import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/guidelines.js"
import { Link } from 'gatsby';
import { Notification } from 'module-tsl-ui-notification';
import { Button } from 'module-tsl-ui-elements';
import LinkableTitle from '../../components/linkableTitle';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<div className="page-welcome-header">
  <h1>Guidelines</h1>
</div>
<div className="page-content">
  <h3>Follow the guidelines below to ensure a smooth contribution process:</h3>
  <LinkableTitle name="accessibility" title="Accessibility" />
  <ul>
    <li>Is your design WCAG AA accessible?</li>
    <li>Does your design pass color contrast ratio?</li>
    <li>Have you considered keyboard tabbing and focus states?</li>
  </ul>
  <LinkableTitle name="componentization" title="Componentization" />
  <p>The components we accept into the global library need to work universally across products.</p>
  <ul>
    <li>Have you tested this design for multiple use cases? It needs to be a pattern that all teams can utilize and global enough to fit use cases for other teams.</li>
    <li>Is there a similar component in the library that already exists?</li>
    <li>What are the advantages of this pattern over alternative patterns?</li>
  </ul>
  <LinkableTitle name="repositories" title="Repositories" />
  <p>The repository for this styleguide</p>
  <a href="https://github.com/tes/app-styleguide" className="page-box page-box--with-icon page-box--github">app-styleguide</a>
  <p>
    The main repository for <b>general / shared</b> ui components. It relies on lerna to have multiple packages under the same repository.<br />
    It contains both the elements and the components packages.
  </p>
  <a href="https://github.com/tes/module-tsl-ui" className="page-box page-box--with-icon page-box--github">module-tsl-ui</a>
  <p>The repository where we store sass mixins and variables.</p>
  <a href="https://github.com/tes/tes-sass" className="page-box page-box--with-icon page-box--github">tes-sass</a>
  <LinkableTitle name="more" title="More on contributing" />
  <Button href="https://internal.tes.com/engineering/docs/more-info/frontend.html">
    Frontend on the Engineering guide
  </Button>
</div>
           </MDXTag>
  }
}

export const _frontmatter = {};

  